import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://mpwrpupkykhdzhjqycrw.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1wd3JwdXBreWtoZHpoanF5Y3J3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM2Njc5NzYsImV4cCI6MjA4OTI0Mzk3Nn0.DqOoxIp5oFubc2tynNoDKn-f12SgSqDLbsNVMyFyZeg'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})